export class ScanProblemTypes {
  id: number;
  ProblemCode: string;
  ProblemDescription: string;
  IsScan1Enabled: boolean;
  IsScan2EmballeurEnabled: boolean;
  DisplayIndex: number;
}
